/**
 *  @module geo/functionalities
 */

import {Observable} from 'rxjs/Observable';

import {FilterContext, FilterValue} from '../types/functionality';

import {Functionality} from '.';

/**
 * Description of analysis execution parameters 
 */
export interface AnalysisExecutionParameters {
  /**
   * list of filters to apply
   */
  filters?: FilterValue[];
  /**
   * text to display in filters panel
   */
  filtersLabel: string;
  /**
   * Special context to apply on filter. Like a features of elements for
   * intersection
   */
  filterContext?: FilterContext;
  /**
   * liste of index of rules to ignore
   */
  ignoreRules: number[];
  /**
   *
   */
  hiddenLabels: boolean|undefined;

  iconId: null;

  printLegendVisibility: 'IF_TRIGGERED';
}

/**
 * A analysis functionality, see  method execute.
 *
 * For instance:
 *
 *
 * - to execute analysis with a specfic filter:
 *
 * ```javascript
 *    geoApp.getFunctionalityById('8e1aca07-30a4-11e8-8810-9787e286647e').execute(
 * {
 *       "filters":
 *             [
 *               {"name":"rowidsupp","values":[300]},
 *               {"name":"rowidinf","values":[350]}
 *             ]
 *    }
 * );
 * ```
 */
export class AnalysisFunctionality extends Functionality {

  getService(): void {
    throw new Error('Method not implemented.');
  }
  static typeDef = 'com.bg.functionality.map.layer.Analysis';

  /**
   * Execute an analysis, with given parameters
   * For example
   *
   *
   * - to execute analysis with a filter:
   * ```
   *    geoApp.getFunctionalityById('8e1aca07-30a4-11e8-8810-9787e286647e').execute(
   * {
   *       "filters":
   *             [
   *               {"name":"rowidsupp","values":[300]},
   *               {"name":"rowidinf","values":[350]}
   *             ]
   *    }
   * );
   * ```
   *
   * @param parameters
   * @returns {Observable<any>}
   */
  public execute(parameters: AnalysisExecutionParameters): Observable<any> {
    return super.execute(parameters);
  }
}

/**
 * Analysis functionality 
 * for version 2 of analysis
 */
export class Analysis2Functionality extends AnalysisFunctionality {
  public static typeDef = 'com.bg.functionality.analysis2.Analysis2';
}